import { Component } from 'react';
import { connect, Provider } from 'react-redux';

import {hasRsvpd, canRSVP} from '../../utils';
import MountComponentOnBody from '../../../common/components/mount-component-on-body';
import RsvpResponseButtons from './rsvp-response-buttons';
import RsvpModalForm from './rsvp-modal-form';


class RsvpResponseBar extends Component {
  render() {
    const showBar = (!this.props.onRsvpTab && !hasRsvpd() && canRSVP());
    return (
      <div>
        <RsvpModalForm />
        { showBar &&
          <MountComponentOnBody store={store} ProvidedProvider={Provider} componentId="rsvp-bar-holder">
            <div className="rsvp-response-bar" >
              <h1>Will you attend?</h1>
              <RsvpResponseButtons />
              <span className="clearfix" />
            </div>
          </MountComponentOnBody>
        }
      </div>
    );
  }
}

function mapStateToRsvpProps(state) {
  return state.rsvp
}

RsvpResponseBar = connect(mapStateToRsvpProps)(RsvpResponseBar);

export { RsvpResponseBar };
export default RsvpResponseBar;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/components/rsvp-response-bar.es6